import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';
import type { SensitivityTooltip } from '../SensitivityTooltip';

export type SensitivityLabelSlots = {
  root: Slot<'span'>;
  label?: Slot<'span'>;
  tooltip?: Slot<typeof SensitivityTooltip>;
};

/**
 * SensitivityLabel Props
 */
export type SensitivityLabelProps = ComponentProps<SensitivityLabelSlots> & { description: string };

/**
 * State used in rendering SensitivityLabel
 */
export type SensitivityLabelState = ComponentState<SensitivityLabelSlots> & {};
